import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Box } from '@chakra-ui/react';
import benchatService from '../../../../../service/benchatService';
import { Line as LineIcon } from '../../../../context/Chakra/Icons';
import { PANEL } from '../../../constants/panel';
import { useAppContext } from '../../../context/appContext';
import {
  EVENT_CATEGORY_FOR_USER_FLOW,
  VALUE_FOR_USER_FLOW,
  PROPERTY_FOR_USER_FLOW,
  EVENT_NAME_FOR_USER_FLOW,
} from '../../../../../shop/constants/signupLoginEventsTracking';
import trackerService from '../../../../../service/trackerService';
import { delayRedirect } from '../../../../../utils/redirect';
import { saveCurrentScrollToMountState } from '../../../../OnePageStoreCheckout/utils/onePageStoreMountState';

const LineAccount = ({ currentPanel, e2eId, isButtonStyle }) => {
  const { lineLoginChannel, isOnePageStorePopup } = useAppContext();
  const url = benchatService.getLineLoginUri(
    lineLoginChannel?.platformChannelId,
  );

  const handleClick = () => {
    if (isOnePageStorePopup) {
      saveCurrentScrollToMountState();
    }

    if (currentPanel === PANEL.SIGN_UP) {
      trackerService.track({
        type: EVENT_NAME_FOR_USER_FLOW.ThirdPartySignUpClick,
        data: {
          event_category: EVENT_CATEGORY_FOR_USER_FLOW.SignUp,
          property: PROPERTY_FOR_USER_FLOW.sign_up_option,
          value: VALUE_FOR_USER_FLOW.line,
        },
      });
    } else if (currentPanel === PANEL.LOGIN) {
      trackerService.track({
        type: EVENT_NAME_FOR_USER_FLOW.ThirdPartyLoginClick,
        data: {
          event_category: EVENT_CATEGORY_FOR_USER_FLOW.MemberLogin,
          property: PROPERTY_FOR_USER_FLOW.login_option,
          value: VALUE_FOR_USER_FLOW.line,
        },
      });
    }

    delayRedirect(url);
  };

  return isButtonStyle ? (
    <Box
      flex={1}
      border="1px solid #e7e7e7"
      borderRadius="4px"
      padding="12px"
      display="flex"
      justifyContent="center"
      alignItems="center"
      cursor="pointer"
      onClick={handleClick}
    >
      <LineIcon color="#06C755" boxSize="20px" mr="8px" />
      <Box fontSize="12px" fontWeight={600} lineHeight="20px">
        LINE
      </Box>
    </Box>
  ) : (
    <IconButton aria-label="facebook login" variant="plain">
      <LineIcon
        data-e2e-id={e2eId}
        color="#06C755"
        boxSize="40px"
        onClick={handleClick}
      />
    </IconButton>
  );
};

LineAccount.propTypes = {
  currentPanel: PropTypes.oneOf([PANEL.LOGIN, PANEL.SIGN_UP]).isRequired,
  e2eId: PropTypes.string,
  isButtonStyle: PropTypes.bool,
};

export default LineAccount;
